import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDecimalMask]'
})
export class DecimalMaskDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  // Разрешаваме само цифри, точка и запетая
  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // махаме всички символи, които не са 0-9, . или ,
    value = value.replace(/[^0-9.,]/g, '');

    // заменяме запетая с точка
    value = value.replace(',', '.');

    // ако има повече от една точка — махаме излишните
    const firstDot = value.indexOf('.');
    if (firstDot !== -1) {
      value = value.substring(0, firstDot + 1) + value.substring(firstDot + 1).replace(/\./g, '');
    }

    // обновяваме полето само ако стойността се е променила
    if (input.value !== value) {
      this.renderer.setProperty(input, 'value', value);
    }
    
}

  // При излизане от фокус — форматираме до 2 десетични
  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(',', '.');

    if (value && !isNaN(+value)) {
      value = parseFloat(value).toFixed(2);
      this.renderer.setProperty(input, 'value', value);
    }
  }
}
